module.exports = __webpack_public_path__ + "media/images/lb/254-be784714c3cb44f66944e97a5805bdc5.svg";